import api from "./Api";

class OrdemServicoService {
  GetOrdemServico(payload) {
    return api.get("/v1/ordemServico/" + payload).then((response) => {
      return response.data;
    });
  }

  PostOrdemServico(payload) {
    return api.post("/v1/ordemServico/", payload).then((response) => {
      return response.data;
    });
  }

  PutOrdemServico(payload) {
    return api.put("/v1/ordemServico/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteOrdemServico(payload) {
    return api.delete("/v1/ordemServico/" + payload).then((response) => {
      return response.data;
    });
  }

  AtualizarFaturamento(payload) {
    return api
      .put("/v1/ordemServico/AtualizarFaturamento", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetOrdemServicoOData(payload) {
    return api.get("/OData/OrdemServico" + payload).then((response) => {
      return response.data;
    });
  }

  ImprimirOrdemServico(payload) {
    return api
      .get("/v1/ordemServico/Imprimir/" + payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
    // return api.get("/v1/ordemServico/Imprimir/" + payload).then((response) => {
    //   return response;
    // });
  }
}

export default new OrdemServicoService();
